import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  verifyCode: {
    data: null,
    error: null,
    loading: false,
  },
  forgotPassword: {
    data: null,
    error: null,
    loading: false,
  },
  createPassword: {
    data: null,
    error: null,
    loading: false,
  },
  resendCode: {
    data: null,
    error: null,
    loading: false,
  },
  emailLink: {
    data: null,
    error: null,
    loading: false,
  },
};

const authSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    forgotPasswordStart: (state) => {
      state.forgotPassword.loading = true;
      state.forgotPassword.error = null;
      state.forgotPassword.data = null;
    },
    forgotPasswordSuccess: (state, action) => {
      state.forgotPassword.loading = false;
      state.forgotPassword.error = null;
      state.forgotPassword.data = action.payload;
    },
    forgotPasswordFailure: (state, action) => {
      state.forgotPassword.loading = false;
      state.forgotPassword.data = null;
      state.forgotPassword.error = action.payload;
    },
    forgotPasswordResetForm: (state, action) => {
      state.forgotPassword.loading = false;
      state.forgotPassword.error = null;
      state.forgotPassword.data = null;
    },
    //Verify Code
    verifyCodeStart: (state) => {
      state.verifyCode.loading = true;
      state.verifyCode.error = null;
      state.verifyCode.user = null;
    },
    verifyCodeSuccess: (state, action) => {
      state.verifyCode.loading = false;
      state.verifyCode.error = null;
      state.verifyCode.data = action.payload;
    },
    verifyCodeFailure: (state, action) => {
      state.verifyCode.loading = false;
      state.verifyCode.data = null;
      state.verifyCode.error = action.payload;
    },
    verifyCodeResetForm: (state, action) => {
      state.verifyCode.loading = false;
      state.verifyCode.error = null;
      state.verifyCode.data = null;
    },
    createPasswordStart: (state) => {
      state.createPassword.data = null;
      state.createPassword.loading = true;
      state.createPassword.error = null;
    },
    createPasswordSuccess: (state, action) => {
      state.createPassword.loading = false;
      state.createPassword.data = action.payload;
      state.createPassword.error = null;
    },
    createPasswordFailure: (state, action) => {
      state.createPassword.loading = false;
      state.createPassword.error = action.payload;
      state.createPassword.data = null;
    },

    resendCodeStart: (state) => {
      state.resendCode.data = null;
      state.resendCode.loading = true;
      state.resendCode.error = null;
    },
    resendCodeSuccess: (state, action) => {
      state.resendCode.loading = false;
      state.resendCode.data = action.payload;
      state.resendCode.error = null;
    },
    resendCodeFailure: (state, action) => {
      state.resendCode.loading = false;
      state.resendCode.error = action.payload;
      state.resendCode.data = null;
    },

    resendCodeReset: (state, action) => {
      state.resendCode.loading = false;
      state.resendCode.error = null;
      state.resendCode.data = null;
    },

    resetForgotPasswordAll: (state, action) => {
      state.forgotPassword.loading = false;
      state.forgotPassword.data = null;
      state.forgotPassword.error = null;

      state.verifyCode.loading = false;
      state.verifyCode.data = null;
      state.verifyCode.error = null;

      state.createPassword.loading = false;
      state.createPassword.data = null;
      state.createPassword.error = null;

      state.resendCode.loading = false;
      state.resendCode.data = null;
      state.resendCode.error = null;
    },

    emailLinkStart: (state) => {
      state.emailLink.loading = true;
      state.emailLink.error = null;
      state.emailLink.user = null;
    },
    emailLinkSuccess: (state, action) => {
      state.emailLink.loading = false;
      state.emailLink.error = null;
      state.emailLink.data = action.payload;
    },
    emailLinkFailure: (state, action) => {
      state.emailLink.loading = false;
      state.emailLink.data = null;
      state.emailLink.error = action.payload;
    },
    emailLinkResetForm: (state, action) => {
      state.emailLink.loading = false;
      state.emailLink.error = null;
      state.emailLink.data = null;
    },
  },
});

export const {
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  forgotPasswordResetForm,

  verifyCodeStart,
  verifyCodeSuccess,
  verifyCodeFailure,

  verifyCodeResetForm,
  createPasswordStart,
  createPasswordSuccess,
  createPasswordFailure,

  resendCodeStart,
  resendCodeSuccess,
  resendCodeFailure,
  resendCodeReset,

  emailVerificationStart,
  emailVerificationSuccess,
  emailVerificationFailure,
  
  resetForgotPasswordAll,
} = authSlice.actions;

export default authSlice.reducer;
